function getCookie(key: string, isParseDisabled?: boolean): string | Object | null {
	if (typeof document === 'undefined') {
		return null;
	}

	const nameEQ = key + '=';
	const cookies = document.cookie.split('; ');

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i];
		while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1, cookie.length);
		}
		if (cookie.indexOf(nameEQ) === 0) {
			let value = cookie.substring(nameEQ.length, cookie.length);

			if (isParseDisabled) return value;

			try {
				value = JSON.parse(value);
			} catch {
				// is a string
				return value;
			}
			// return the parsed object
			return value;
		}
	}

	return null;
}

function setCookie(key: string, value: string | Object, days?: number): void {
	if (typeof document === 'undefined') {
		return;
	}

	try {
		let toSaveValue = value;

		if (typeof toSaveValue === 'object') {
			toSaveValue = JSON.stringify(value);
		}

		let expires = '';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}

		document.cookie = key + '=' + (toSaveValue as string) + expires + '; path=/';
	} catch (err) {
		console.error('Error setting cookie: ', err);
	}
}

function removeCookie(key: string): void {
	try {
		setCookie(key, '', -1);
	} catch (err) {
		console.error('Error removing cookie: ', err);
	}
}

function clearCookies(): void {
	try {
		const cookies = document.cookie.split('; ');

		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i];
			const eqPos = cookie.indexOf('=');
			const key = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
			removeCookie(key);
		}
	} catch (err) {
		console.error('Error clearing cookies: ', err);
	}
}

export { getCookie, setCookie, removeCookie, clearCookies };
